// src/components/Loader.js
import React from 'react';

// Fullscreen Loader Component
const Loding_compo = () => {

  return (
    <div style={styles.overlay}>
        
        <div style={{position:'absolute',top:'14%'}}>
        <img src="home/images/logo_tara.png" style={{maxWidth:'56%'}} />
        </div>
        
      <div style={styles.loader}>
      </div>

      <div style={{position:'absolute',top:'90%'}}>
      <p style={{color:'#007bff'}}>Loading...</p>
        <p style={{color:'gray'}}>App version:3.0</p>
        </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection:'column',
    alignItems: 'center',
    zIndex: 9999, // Make sure the loader appears on top
    backgroundColor:'white'
  },
  loader: {
    border: '8px solid #f3f3f3',
    borderTop: '8px solid #007bff',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    position:'absolute',
    animation: 'spin 2s linear infinite',
    top:'59%'
  },
};

export default Loding_compo;
